import React from 'react';

const FilterItem = ({
  field,
  isHighlighted,
  onClick,
  onMouseEnter,
}) => {
  return (
    <li>
      <button
        type="button"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        className={`w-full px-1.5 py-2 text-xs md:text-[13px] leading-[15.73px] text-start border-transparent rounded-[4px] capitalize ${
          isHighlighted ? 'bg-[#4d5464]' : ''
        } text-[#EEEFFC]`}
      >
        {field?.icon}
        {field?.label}
      </button>
    </li>
  );
};

export default FilterItem;